import React, { useState } from "react";
import Topbar from "../../components/Topbar";
import Sidebar from "../../components/Sidebar";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

function CreateCoupon() {
  const token = sessionStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const [formdata, setFormdata] = useState({
    type: "",
    code: "",
    value: "",
    starting_date: "",
    ending_date: "",
  });

  const handleChange = (e) => {
    setFormdata({ ...formdata, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_APIURL}api/coupon/create`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(formdata),
        }
      );

      let data;
      try {
        data = await response.json();
      } catch {
        data = { message: "Unexpected response from server" };
      }

      if (response.ok) {
        toast.success("Coupon added successfully!");
        setFormdata({
          type: "",
          code: "",
          value: "",
          starting_date: "",
          ending_date: "",
        });
      } else {
        toast.error(data.message || "Failed to add Coupon");
      }
    } catch (error) {
      toast.error("Something went wrong! Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Topbar />
      <Sidebar />
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Coupon</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item active">Add Coupon</li>
            </ol>
          </nav>
        </div>

        <div className="card">
          <div className="card-body">
            <form className="row g-3 pt-4" onSubmit={handleSubmit}>
              <div className="col-md-4">
                <div className="form-floating">
                  <select
                    className="form-select"
                    name="type"
                    value={formdata.type}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Type</option>
                    <option value="fixed">Fixed</option>
                    <option value="percentage">Percentage</option>
                  </select>
                  <label htmlFor="name">Coupon Type</label>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-floating">
                  <input
                    type="text"
                    className="form-control"
                    id="code"
                    placeholder="Enter Coupon Code"
                    name="code"
                    value={formdata.code}
                    onChange={handleChange}
                    required
                  />
                  <label htmlFor="code">Coupon Code</label>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-floating">
                  <input
                    type="text"
                    className="form-control"
                    id="value"
                    placeholder="Enter Coupon Value"
                    name="value"
                    value={formdata.value}
                    onChange={handleChange}
                    required
                  />
                  <label htmlFor="value">Coupon Value</label>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-floating">
                  <input
                    type="date"
                    className="form-control"
                    id="stdate"
                    name="starting_date"
                    value={formdata.starting_date}
                    onChange={handleChange}
                    required
                  />
                  <label htmlFor="stdate">Start Date</label>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-floating">
                  <input
                    type="date"
                    className="form-control"
                    id="enddate"
                    name="ending_date"
                    value={formdata.ending_date}
                    onChange={handleChange}
                    required
                  />
                  <label htmlFor="enddate">End Date</label>
                </div>
              </div>

              <div className="text-start d-flex gap-3 mt-4">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? "Adding..." : "Add Coupon"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </main>
    </>
  );
}

export default CreateCoupon;
